const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  lanList: state => state.user.lanList,
  isSignAgreement: state => state.user.isSignAgreement,
  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes,
  sidebarRouters: state => state.permission.sidebarRouters,
  userEmail: state => state.user.userEmail,
  contractNo: state => state.user.contractNo,
  userAddress: state => state.user.userAddress,
  userPhone: state => state.user.userPhone,
  enterpriseName: state => state.user.enterpriseName,
  devRights: state => state.user.devRights, //'11111':第一位：渠道包权限，第二位：指定包权限，第三位：依赖包权限，第四位：新版本介绍权限，第五位：获取token权限
  globalBaseUrl: state => state.baseurl.globalBaseUrl
}
export default getters
